
import { defineComponent, computed, onMounted } from "vue";
import DateRangeCompare from "../components/date-range-compare.vue";
import { OptionsClass } from "@/domain/entities/MainApp";
import { DateRange } from "./type";

export default defineComponent({
  name: "FilterGrouping",
  components: { DateRangeCompare },
  props: {
    dates: { type: DateRange, default: () => new DateRange() },
    groupBy: { type: OptionsClass, default: () => new OptionsClass() }
  },
  emits: ["update:dates", "update:groupBy", "filter"],
  setup(props, { emit }) {
    const listGroupBy = [
      new OptionsClass({ name: "Daily", value: "daily" }),
      new OptionsClass({ name: "Weekly", value: "weekly" }),
      new OptionsClass({ name: "Monthly", value: "monthly" })
    ];

    // ✅ reactive bridge for v-model
    const localDates = computed({
      get: () => props.dates,
      set: (value: DateRange) => emit("update:dates", value)
    });

    const localGroupBy = computed({
      get: () => props.groupBy,
      set: (value: OptionsClass) => emit("update:groupBy", value)
    });

    const onFilter = () => emit("filter");

    onMounted(() => {
      localGroupBy.value = new OptionsClass(listGroupBy[0]);
    });

    return {
      listGroupBy,
      localDates,
      localGroupBy,
      onFilter
    };
  }
});
